import { HttpClient } from 'modules/http-client'

import { DepartmentLookup, Lookup } from './models'

// @URL: https://dev-perfman2-api.hciapp.net/swagger/#!/Lookup/V1LookupGet
const NAMESPACE = 'lookup'
const api = {
  base: () => `${NAMESPACE}`,
  departments: () => `${NAMESPACE}/departments`,
}

export class LookupService {
  constructor(private httpClient: HttpClient) {}
  getAll() {
    return this.httpClient.get<Lookup>(api.base()).then(({ data }) => data)
  }
  getDepartments() {
    return this.httpClient.get<DepartmentLookup[]>(api.departments()).then(({ data }) => data)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/lookup/lookup.service.ts